import Routes from '@common/defs/routes';
import useAdmin from '@modules/admin/hooks/useAdmin';
import useAuth from '@modules/auth/hooks/api/useAuth';
import { ROLE } from '@modules/permissions/defs/types';
import useRoles from '@modules/roles/hooks/useRoles';
import QueryStats from '@mui/icons-material/QueryStats';
import { Button, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { SubdirectoryArrowLeft } from '@mui/icons-material';
import { safeLocalStorage } from '@common/utils/storage';

interface AdminButtonProps {
  size?: number;
  text?: string;
}
const AdminButton = (props: AdminButtonProps) => {
  const { size = 35, text = '' } = props;
  const router = useRouter();
  const [hasPreviousAdminToken, setHasPreviousAdminToken] = useState(false);
  const { user } = useAuth();
  const { restoreAdminAccount } = useAdmin();
  const { hasRole } = useRoles();
  const isAdmin = hasRole(ROLE.ADMIN);

  useEffect(() => {
    const previousToken = safeLocalStorage.getItem('previousAuthToken');
    setHasPreviousAdminToken(!!previousToken);
  }, [user]);

  const handleRestoreAdmin = async () => {
    const restored = await restoreAdminAccount();
    if (restored) {
      const returnPath = safeLocalStorage.getItem('adminReturnPath');
      safeLocalStorage.removeItem('adminReturnPath');
      router.push(returnPath || Routes.Admin.Stats);
    }
  };
  return (
    <>
      {hasPreviousAdminToken && (
        <Button
          variant="contained"
          color="warning"
          onClick={handleRestoreAdmin}
          sx={{
            background:
              'linear-gradient(to bottom, rgba(0, 152, 64, 0.65) 0%, rgba(0, 152, 64, 0.9) 100%)',

            borderRadius: '500px',
            boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.3)',
            padding: size * 0.025,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            width: text ? '100%' : size,
            minWidth: text ? '100%' : size,
            height: size,
            '&:hover': {
              filter: 'brightness(1.2)',
            },
          }}
        >
          <SubdirectoryArrowLeft sx={{ color: 'common.white' }} />
        </Button>
      )}
      {isAdmin && (
        <Button
          onClick={() => {
            router.push(Routes.Admin.Home);
          }}
          sx={{
            background:
              'linear-gradient(to bottom, rgba(0, 152, 64, 0.65) 0%, rgba(0, 152, 64, 0.9) 100%)',

            borderRadius: '500px',
            boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.3)',
            padding: size * 0.025,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            width: text ? '100%' : size,
            minWidth: text ? '100%' : size,
            height: size,
            '&:hover': {
              filter: 'brightness(1.2)',
            },
          }}
        >
          <QueryStats sx={{ color: 'common.white' }} />
          {text && (
            <Typography variant="body1" sx={{ color: 'common.white', ml: 1, whiteSpace: 'nowrap' }}>
              {text}
            </Typography>
          )}
        </Button>
      )}
    </>
  );
};

export default AdminButton;
